import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
// Self-hosted variable font (bundled + hashed by Vite; includes latin-ext for č ć ž š đ).
import '@fontsource-variable/plus-jakarta-sans'
import './i18n'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
